// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getPurchaseTypes} from '../../../product/shared/repositories';

export const readFilteredPurchaserType = (filterKey, filterOperator, filterValue) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getPurchaseTypes(filterKey, filterOperator, filterValue);

            dispatch({
                data,
                property: 'purchaseTypes',
                type: actions.UPDATE_NEW_REGISTRATION_DOMAIN_VALUES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/filtered-purchaser-type.js